module.exports = __webpack_public_path__ + "static/img/51.4ccf817.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/51.png
// module id = oDEf
// module chunks = 1